module.exports = __webpack_public_path__ + "media/images/common-nav/free-camping/oregon-1c7ba729211319030af28f0b492bb113.jpg";